// extracted by mini-css-extract-plugin
export default {"brand_product":"Product_brand_product__ZNsQC","status":"Product_status__tlt1l","action_btn":"Product_action_btn__-VrUU","competitor":"Product_competitor__8KO2-"};